import request from '@/api/util/request'
import baseURL from '@/api/util/baseUrl'

// 添加新接运
export function bookCar(data) {
  return request({
    url: '/fisapp/bookCar/fis-drive-book/book',
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    data: data,
    baseURL: baseURL.ensure
  })
}
// 获取接运信息
export function getBook(data) {
  return request({
    url: '/fisapp/bookCar/fis-drive-book/getBook',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

// 获取殡仪馆信息
export function getFuneralOrgan(data) {
  return request({
    url: '/fisapp/cooperate/fis_funeral_organ/getFuneralOrgan',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

// 获取联办事项
export function getMatterInfoList(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-matter-info/getMatterInfoList',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}


// 获取联办事项详情
export function getBusinessList(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-matter-info/getBusinessList',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

// 存储联办事项
export function saveMatter(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-matter/saveMatter',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

// 提交后修改联办事项信息状态
export function upMatter(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-matter/upMatter',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

// 存储申请人逝者信息
export function saveCustom(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-custom/saveCustom',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}
export function getCustomByMatterId(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-custom/getCustomByMatterId',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

export function getDeadByMatterId(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-dead/getDeadByMatterId',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

export function getMatterByMatterId(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-matter/getMatterByMatterId',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

// 存储补采信息
export function saveInfomation(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-custom/saveInfomation',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

// 获取字典
export function getDictItem(data) {
  return request({
    url: '/fisapp/cooperate/dic_item/getDictItem',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

// 获取签名二维码
export function getSignatureQR(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-apply/signature',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

// 获取区划
export function getDictCity(data) {
  return request({
    url: '/fisapp/cooperate/dic_city/getDictCity',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

// 获取区划
export function getDictCityList(data) {
  return request({
    url: '/fisapp/cooperate/dic_city/getDictCityList',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

// 获取文件上传页面列表
export function getFileList(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-file/getFileList',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

// 获取联办事项文件上传详情
export function getInfoList(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-matter-info/getInfoList',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}

// 获取文件上传页面列表
export function deleteFile(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-file/deleteFile',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}
// 获取电子签名二维码
export function signature(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-apply/signature',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}
// 获取电子签名图片
export function getSignature(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-apply/getSignature',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}
// 存储签名信息
export function saveSignature(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-apply/saveSignature',
    method: 'post',
    data: data,
    baseURL: baseURL.ensure
  })
}
// 获取身份证户口簿电子证照
export function getZjInformation(data) {
  return request({
    url: '/fisapp/dzzz/getZjInformation',
    method: 'post',
    baseURL: baseURL.ensure,
    data: data
  })
}

// 卫健接口获取死亡信息
export function getDeadZjInformation(data) {
  return request({
    url: '/fisapp/dzzz/getDeadZjInformation',
    method: 'post',
    baseURL: baseURL.ensure,
    data: data
  })
}

// 公安接口获取死亡信息
export function getDeadGaInformation(data) {
  return request({
    url: '/fisapp/dzzz/getDeadGaInformation',
    method: 'post',
    baseURL: baseURL.ensure,
    data: data
  })
}

// 公安接口获取驾驶证信息
export function getDeadCarInformation(data) {
  return request({
    url: '/fisapp/dzzz/getDeadCarInformation',
    method: 'post',
    baseURL: baseURL.ensure,
    data: data
  })
}

//办件中心申报接口

export function submit(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-apply/submit',
    method: 'post',
    baseURL: baseURL.ensure,
    data: data
  })
}
// 获取婚姻状态
export function getMarryStatus(data) {
  return request({
    url: '/fisapp/dzzz/getMarryStatus',
    method: 'post',
    baseURL: baseURL.ensure,
    data: data
  })
}

// 获取是否已办理一件事
export function checkIdCard(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-dead/checkIdCard',
    method: 'post',
    baseURL: baseURL.ensure,
    data: data
  })
}

export function changeMatterId(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-matter/changeMatterId',
    method: 'post',
    baseURL: baseURL.ensure,
    data: data
  })
}

export function saveCarMatter(data) {
  return request({
    url: '/fisapp/cooperate/fis-cooperate-matter/saveCarMatter',
    method: 'post',
    baseURL: baseURL.ensure,
    data: data
  })
}
export function queryMatterList(customIdCard) {
  return request({
    url: '/fisapp/common/fis-cremationCert/queryMatterList',
    method: 'get',
    params: {
      customIdCard: customIdCard
    },
    baseURL:baseURL.ensure
  })
}
